import { type ReactNode } from 'react'
import { AccessDeniedPage, LoadingSpinner } from '@m3-tech/boss-ui'
import { useEmployee } from '@/hooks/useEmployee'
import { canAccessLaDrcTemplates } from '@/utils/template.utils'

interface TemplateGuardedRouteProps {
    children: ReactNode
}

/**
 * Guards the LA/DRC template routes (C260774). The user may enter only when they
 * hold the Hub or Deal-Review grant (`optionHub || optionDealReview`), matching the
 * legacy nav gate. Task Templates routes are intentionally left ungated.
 */
export function TemplateGuardedRoute({ children }: TemplateGuardedRouteProps) {
    const { data: employeeData, isLoading } = useEmployee()

    if (isLoading) return <LoadingSpinner />

    if (!canAccessLaDrcTemplates(employeeData)) return <AccessDeniedPage />

    return <>{children}</>
}
